var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-view',_vm._l((_vm.categoryDetail),function(item,index){return _c('new-goods-item',{key:index,attrs:{"iid":item.iid,"img":item.img,"title":item.title,"price":item.price,"collect":item.cfav}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }